import * as CardCrawl from "@ravalmatic/cardcrawl-engine";
import { Language } from "../Types";
import { GameVars } from "../GameVars";

export class Utils {

    public static getCardNameStr(type: string, initialValue: number): string {

        const lan = GameVars.gameData.language;
        const text = GameVars.currentScene.cache.json.get("text");

        switch (type) {

            case CardCrawl.CardType.POTION:
                return text.POTION_NAME[lan];
            case CardCrawl.CardType.SWORD:
                return text.SWORD_NAME[lan];
            case CardCrawl.CardType.SHIELD:
                return text.SHIELD_NAME[lan];
            case CardCrawl.CardType.GOLD:
                return text.GOLD_NAME[lan];

            case CardCrawl.CardType.ENEMY:

                switch (initialValue) {

                    case 2:
                        return text.ENEMY_NAME_2[lan];
                    case 3:
                        return text.ENEMY_NAME_3[lan];
                    case 4:
                        return text.ENEMY_NAME_4[lan];
                    case 5:
                        return text.ENEMY_NAME_5[lan];
                    case 6:
                        return text.ENEMY_NAME_6[lan];
                    case 7:
                        return text.ENEMY_NAME_7[lan];
                    case 8:
                        return text.ENEMY_NAME_8[lan];
                    case 9:
                        return text.ENEMY_NAME_9[lan];
                    case 10:
                        return text.ENEMY_NAME_10[lan];
                    default:
                        return "enemy";
                }

            // cartas especiales
            case CardCrawl.CardType.SWAP:
                return text.SWAP_NAME[lan];
            case CardCrawl.CardType.STEAL:
                return text.STEAL_NAME[lan];
            case CardCrawl.CardType.REVIVE:
                return text.REVIVE_NAME[lan];
            case CardCrawl.CardType.POTIONIZE:
                return text.POTIONIZE_NAME[lan];
            case CardCrawl.CardType.FLAIL:
                return text.FLAIL_NAME[lan];
            case CardCrawl.CardType.SACRIFICE:
                return text.SACRIFICE_NAME[lan];
            case CardCrawl.CardType.BETRAYAL:
                return text.BETRAYAL_NAME[lan];
            case CardCrawl.CardType.EXCHANGE:
                return text.EXCHANGE_NAME[lan];
            case CardCrawl.CardType.REFLECT:
                return text.REFLECT_NAME[lan];
            case CardCrawl.CardType.KILLING_BLOW:
                return text.KILLING_BLOW_NAME[lan];
            case CardCrawl.CardType.LASH:
                return text.LASH_NAME[lan];
            case CardCrawl.CardType.LUCKY_SHOT:
                return text.LUCKY_SHOT_NAME[lan];
            case CardCrawl.CardType.BASH:
                return text.BASH_NAME[lan];
            case CardCrawl.CardType.VANISH:
                return text.VANISH_NAME[lan];
            case CardCrawl.CardType.LEECH:
                return text.LEECH_NAME[lan];

            default:
                return "no name";
        }
    }

    public static getCardImageName(type: string, value: number): string {

        let cardImageName: string;

        switch (type) {

            case CardCrawl.CardType.SWORD:

                if (value < 4) {
                    cardImageName = "spell_1";
                } else if (value < 6) {
                    cardImageName = "spell_2";
                } else {
                    cardImageName = "spell_3";
                }
                break;

            case CardCrawl.CardType.POTION:

                if (value < 4) {
                    cardImageName = "potion_1";
                } else if (value < 9) {
                    cardImageName = "potion_2";
                } else {
                    cardImageName = "potion_3";
                }
                break;

            case CardCrawl.CardType.SHIELD:

                if (value < 4) {
                    cardImageName = "shield_1";
                } else if (value < 6) {
                    cardImageName = "shield_2";
                } else {
                    cardImageName = "shield_3";
                }
                break;
            
            case CardCrawl.CardType.GOLD:

                if (value < 5) {
                    cardImageName = "gold_1";
                } else if (value < 8) {
                    cardImageName = "gold_2";
                } else {
                    cardImageName = "gold_3";
                }
                break;

            case CardCrawl.CardType.ENEMY:

                cardImageName = "enemy_" + value;
                break;

            case CardCrawl.CardType.PLAYER:

                if (value === 0) {
                    cardImageName = "hero_5";
                } else if (value < 5) {
                    cardImageName = "hero_4";
                } else if (value < 8) {
                    cardImageName = "hero_3";
                } else  if (value < 11) {
                    cardImageName = "hero_2";
                } else {
                    cardImageName = "hero_1";
                }

                break;

            default:
                cardImageName = type.toLowerCase();
        }

        return cardImageName;
    }

    public static getSpecialCardDescription(type: string): string {

        const lan = GameVars.gameData.language;
        const text = GameVars.currentScene.cache.json.get("text");

        switch (type) {

            case CardCrawl.CardType.SWAP:
                return text.SWAP_DESCRIPTION[lan];
            case CardCrawl.CardType.STEAL:
                return text.STEAL_DESCRIPTION[lan];
            case CardCrawl.CardType.REVIVE:
                return text.REVIVE_DESCRIPTION[lan];
            case CardCrawl.CardType.POTIONIZE:
                return text.POTIONIZE_DESCRIPTION[lan];
            case CardCrawl.CardType.FLAIL:
                return text.FLAIL_DESCRIPTION[lan];
            case CardCrawl.CardType.SACRIFICE:
                return text.SACRIFICE_DESCRIPTION[lan];
            case CardCrawl.CardType.BETRAYAL:
                return text.BETRAYAL_DESCRIPTION[lan];
            case CardCrawl.CardType.EXCHANGE:
                return text.EXCHANGE_DESCRIPTION[lan];
            case CardCrawl.CardType.REFLECT:
                return text.REFLECT_DESCRIPTION[lan];
            case CardCrawl.CardType.KILLING_BLOW:
                return text.KILLING_BLOW_DESCRIPTION[lan];
            case CardCrawl.CardType.LASH:
                return text.LASH_DESCRIPTION[lan];
            case CardCrawl.CardType.LUCKY_SHOT:
                return text.LUCKY_SHOT_DESCRIPTION[lan];
            case CardCrawl.CardType.BASH:
                return text.BASH_DESCRIPTION[lan];
            case CardCrawl.CardType.VANISH:
                return text.VANISH_DESCRIPTION[lan];
            case CardCrawl.CardType.LEECH:
                return text.LEECH_DESCRIPTION[lan];
            default:
                return null;
        }
    }

    public static getBrowserLanguage(): string {

        // return Language.ES; 

        const lang = navigator.language.slice(0, 2) || navigator["userLanguage"];

        switch (lang) {

            case Language.EN:
            case Language.ES:
            case Language.DE:
            case Language.FR:
            case Language.IT:
            case Language.PT:
            case Language.NL:
                return lang;
            default:
                return Language.EN; // Retorna 'en' para cualquier otra variante del inglés o idiomas no listados
        }
    }

    public static getGlobalPosition(displayObject: Phaser.GameObjects.Container | Phaser.GameObjects.Sprite | Phaser.GameObjects.Image): Phaser.Math.Vector2 {

        let globalPosition = new Phaser.Math.Vector2(displayObject.x, displayObject.y);
        let currentObject = displayObject.parentContainer;
    
        while (currentObject) {
            globalPosition.x += currentObject.x;
            globalPosition.y += currentObject.y;
            currentObject = currentObject.parentContainer;
        }
    
        return globalPosition;
    }

    public static isMoveValid(item: string, i: number): boolean {

        if(GameVars.allowedMoves === null) {
            return false;
        }

        let isMoveValid = false;

        switch (item) {
            case CardCrawl.TableauType.UPPER:
                isMoveValid = GameVars.allowedMoves.upperTableau[i];
                break;
            case CardCrawl.TableauType.LOWER:
                isMoveValid = GameVars.allowedMoves.lowerTableau[i];
                break;
            case CardCrawl.TableauType.SHOP:
                isMoveValid = GameVars.allowedMoves.chest;
                break;
            default:
        }

        return isMoveValid;
    }

    // ESTO ESTABA EN TutorialManager.ts PERO SE CREABA UNA REFERENCIA CIRCULAR
    public static isCardSelectionBlocked(cardData: CardCrawl.CardData): boolean {

        const now = Date.now();

        if (now < GameVars.tutorialStepData.t + GameVars.tutorialStepData.delay / 3) {
            return true;
        }

        if (GameVars.tutorialStepData.from === null) {
            return true;
        } else {
            return !(cardData.tableau === GameVars.tutorialStepData.from.tableau && cardData.i === GameVars.tutorialStepData.from.i);
        }
    }
}
